import {atom} from "recoil";

export const userState = atom({
    key: "userState",
    default: {
        name: "",
        email: "",
        avatar: '',
        current_plan: null,
    },
})
export const currentProjectState = atom({
    key: "currentProject",
    default: null
})
export const speakersState = atom({
    key: "speakersState",
    default: []
})

/* Sidebar expand/collapse state — shared so the toggle can live in the page
   Header (left of the title) while SidebarNavigation reacts to it. */
export const sidebarExpandedState = atom({
    key: "sidebarExpandedState",
    default: false,
})

/* ---- YouTube Auto-Dub ----
   Central channel registry (PRD §10: "one registry, two roles"). The picker
   source grid, Step-3 destination chips and the Channels page are all views
   over this one atom; connecting a channel mid-flow appends here and shows
   everywhere. Seeded from GET /channels by useAutoDubChannels. */
export const autoDubChannelsState = atom({
    key: "autoDubChannelsState",
    default: [],
})

/* Workflows created by / shown in the Auto-Dub feature. Activating the builder
   prepends a new workflow; Landing & Detail read from here. Seeded from
   GET /workflows by useAutoDubWorkflows. */
export const autoDubWorkflowsState = atom({
    key: "autoDubWorkflowsState",
    default: [],
})
